"use strict";
/**
 * @module Services
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Codec = require("./../io/codec");
var serialiser_1 = require("./../serialisers/serialiser");
var error_report_1 = require("./../services/error-report");
/**
 * Serialiser for {@link ErrorReport}
 */
var ErrorReportSerialiserClass = /** @class */ (function (_super) {
    __extends(ErrorReportSerialiserClass, _super);
    function ErrorReportSerialiserClass() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Read an error report from the stream
     *
     * @param bis the input stream
     * @return    the error report that was read
     */
    ErrorReportSerialiserClass.prototype.read = function (input) {
        var message = Codec.readString(input);
        var line = Codec.readInt32(input);
        var column = Codec.readInt32(input);
        return new error_report_1.ErrorReportImpl(message, line, column);
    };
    /**
     * Write an error report to the stream
     *
     * @param bis   the input stream
     * @param value the error report to be written
     */
    ErrorReportSerialiserClass.prototype.write = function (output, value) {
        Codec.writeString(output, value.message);
        Codec.writeInt32(output, value.line);
        Codec.writeInt32(output, value.column);
    };
    return ErrorReportSerialiserClass;
}(serialiser_1.AbstractSerialiser));
exports.ErrorReportSerialiserClass = ErrorReportSerialiserClass;
/**
 * The {@link ErrorReportSerialiser} singleton
 */ // tslint:disable-next-line:variable-name
exports.ErrorReportSerialiser = new ErrorReportSerialiserClass();



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/error-report-serialiser.js
// module id = 285
// module chunks = 0